import api from 'modules/api/index';

export const enableEmailVerificationRequest = (payload) => {
  const { userId } = payload;

  return api.post(`/users/${userId}/enable-email-verification`, payload);
};
